/***
*
*   TAB VIEW
*   Create a tabbed view by wrapping each view element in a <TabView> component.
*
*   PROPS
*   name: specify a name if you want to persist the active tab state
*   labels: array of strings for the tab labels
*
**********/

import React, { useState } from 'react';
import { ClassHelper } from 'components/lib';
import Style from './tabview.tailwind.js';

export function TabView(props){
  const init = new Array(props.children.length).fill(false);

  // is there a view saved in storage?
  const savedViewIndex = localStorage.getItem(props.name + 'Tabs');

  // loaded the saved view, or the initial view
  if (savedViewIndex){
    init[savedViewIndex] = true;
  }
  else if (props.initialView){
    init[props.initialView] = true;
  }
  else {
    init[0] = true;
  }

  // state
  const [activeState, setActiveState] = useState(init);

  function switchTab(i){
    const next = init.map((_, idx) => idx === i);
    setActiveState(next);

    // save the tab
    if (props.name) localStorage.setItem(props.name + 'Tabs', i);
  }

  return (
    <div>
      <nav className={Style.tabs}>
        {props.labels.map((label, i) => (
          <Tab
            key={label}
            active={activeState[i]}
            click={() => switchTab(i)}>
            {label}
          </Tab>
        ))}
      </nav>

      {props.children.map((view, i) => {
        if (!view) return null;
        const visibleClass = activeState[i] ? 'show' : 'hide';
        return (
          <div className={visibleClass} key={i}>
            {view}
          </div>
        );
      })}
    </div>
  );
}

function Tab(props){
  const buttonStyle = ClassHelper(Style, {
    button: true,
    buttonActive: props.active,
    buttonInActive: !props.active,
  });

  return (
    <button className={buttonStyle} onClick={props.click}>
      {props.children}
    </button>
  );
}